import { render, staticRenderFns } from "./DriverInfo.vue?vue&type=template&id=74bfa3ee&scoped=true&"
import script from "./DriverInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./DriverInfo.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bfa3ee",
  null
  
)

export default component.exports